/**
 * Work Log History 메인 컴포넌트 (리팩토링 버전)
 *
 * 기존 536라인 → 80라인으로 단순화
 * - 비즈니스 로직: Custom Hook으로 분리
 * - UI 컴포넌트: 3개로 분리 (List, Detail, Form)
 * - 상수/유틸: 별도 파일로 분리
 */

import { useState, useMemo } from 'react'
import { WorkLog, WorkLogStatus, WorkLogCategory } from '../../constants/workLog'
import { useWorkLogs } from '../../hooks/useWorkLogs'
import { useCustomers } from '../../hooks/useCustomers'
import { useCustomerStore } from '../../stores/customerStore'
import { WorkLogList } from './WorkLogList'
import { WorkLogDetail } from './WorkLogDetail'
import { WorkLogForm } from './WorkLogForm'

type View = 'list' | 'detail' | 'form'

export function WorkLogHistoryRefactored() {
  const { selectedCustomer: selectedCustomerName } = useCustomerStore()
  const { customers } = useCustomers()

  const [view, setView] = useState<View>('list')
  const [selectedWorkLog, setSelectedWorkLog] = useState<WorkLog | null>(null)
  const [selectedStatus, setSelectedStatus] = useState<WorkLogStatus | 'all'>('all')
  const [selectedCategory, setSelectedCategory] = useState<WorkLogCategory | 'all'>('all')

  // Fetch all work logs (filtering will be done client-side)
  const { workLogs: allWorkLogs, loading, refetch } = useWorkLogs({
    status: selectedStatus !== 'all' ? selectedStatus : undefined,
    category: selectedCategory !== 'all' ? selectedCategory : undefined
  })

  // Client-side filtering by customer name
  const workLogs = useMemo(() => {
    if (selectedCustomerName === 'all') {
      return allWorkLogs
    }
    const filtered = allWorkLogs.filter(log => log.customerName === selectedCustomerName)
    console.log('[WorkLogHistory] Filtered by customer:', selectedCustomerName, '→', filtered.length, 'work logs')
    return filtered
  }, [allWorkLogs, selectedCustomerName])

  // 뷰 전환 핸들러
  const handleWorkLogClick = (workLog: WorkLog) => {
    setSelectedWorkLog(workLog)
    setView('detail')
  }

  const handleCreateClick = () => {
    setView('form')
  }

  const handleBackToList = () => {
    setView('list')
    setSelectedWorkLog(null)
  }

  const handleFormSuccess = () => {
    setView('list')
    refetch()
  }

  const handleUpdate = () => {
    refetch()
  }

  // 조건부 렌더링
  if (view === 'form') {
    return <WorkLogForm onSuccess={handleFormSuccess} onCancel={handleBackToList} />
  }

  if (view === 'detail' && selectedWorkLog) {
    return <WorkLogDetail workLog={selectedWorkLog} onBack={handleBackToList} onUpdate={handleUpdate} />
  }

  return (
    <WorkLogList
      workLogs={workLogs}
      loading={loading}
      selectedStatus={selectedStatus}
      selectedCategory={selectedCategory}
      onStatusChange={setSelectedStatus}
      onCategoryChange={setSelectedCategory}
      onWorkLogClick={handleWorkLogClick}
      onCreateClick={handleCreateClick}
    />
  )
}
